import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';

import {
  getEmployees,
  setFilters,
  setPagination,
  reset,
  getEmployeesReportCSV,
} from 'employees/actions';

import { getCompany, getSubcompany } from 'auth/selectors';

import { getPagination, getFilters, getNeedFetch } from 'employees/selectors';

import { valueFromEvent, saveAsCSV } from 'lib/util';
import { translate } from 'react-i18next';

class EmployeesListHandlers extends Component {
  static propTypes = {
    r: PropTypes.func.isRequired,
  };
  state = {
    columnSearch: [
      // Cambiar por redux
      { key: 'key', name: this.props.t('employees.searchEditor.key'), search: true },
      { key: 'name', name: this.props.t('employees.searchEditor.name'), search: true },
      { key: 'lastname', name: this.props.t('employees.searchEditor.lastname'), search: true },
      { key: 'email', name: this.props.t('employees.searchEditor.email'), search: true },
      { key: 'position', name: this.props.t('employees.searchEditor.position'), search: true },
    ],
  };

  handleToggleSearch = (col) => {
    let columnsNuevo = this.state.columnSearch;
    let datos = columnsNuevo.find((column) => column.key == col);
    datos.search = !datos.search;
    this.setState({ columnSearch: columnsNuevo });
    let columnsSearch = [];
    columnsNuevo.forEach((e) => {
      if (e.search) {
        columnsSearch.push(e.key);
      }
    });
    this.props.setFilters({ columnSearch: columnsSearch }); // Agregado a Redux
  };

  componentWillMount = () => this.fetch(this.props.pagination, this.props.filters);
  componentWillUnmount = () => this.props.reset();
  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.needFetch &&
      (!isEqual(nextProps.pagination, this.props.pagination) ||
        !isEqual(nextProps.filters, this.props.filters))
    ) {
      this.fetchDebounced(nextProps.pagination, nextProps.filters);
    }
  };

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handleLimitChange = (limit) => this.props.setPagination({ limit: parseInt(limit, 10) });

  handlePageChange = (page) => this.props.setPagination({ page: parseInt(page, 10) });

  handleFiltersChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleSubmit = () => this.fetch(this.props.pagination, this.props.filters);

  fetch = (pagination, filters) => {
    const { limit, page, orderBy, order } = pagination;
    const { company, subcompany } = this.props;

    this.props.getEmployees(company.id, subcompany.id, filters, limit, page, orderBy, order);
  };

  handleExport = () => {
    const { company, subcompany } = this.props;

    this.props
      .getReportCSV(company.id, subcompany.id, this.props.filters)
      .then(({ value: { data } }) => saveAsCSV(`Empleados`, this.props.filters.endDate, data))
      .catch((e) => {});
  };

  fetchDebounced = debounce(this.fetch, 200);

  render = () =>
    this.props.render({
      handleExport: this.handleExport,
      handleOrderChange: this.handleOrderChange,
      handleLimitChange: this.handleLimitChange,
      handlePageChange: this.handlePageChange,
      handleFiltersChange: this.handleFiltersChange,
      handleSubmit: this.handleSubmit,
      handleToggleSearch: this.handleToggleSearch,
      columnSearch: this.state.columnSearch,
    });
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  needFetch: getNeedFetch(state),
});

const mapDispatchToProps = {
  getEmployees,
  setFilters,
  setPagination,
  reset,
  getReportCSV: getEmployeesReportCSV,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(EmployeesListHandlers);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/containers/EmployeesListHandlers.js